import { createModel } from '@rematch/core';
import type { RootModel } from './models';

type ProviderAvailabilityBadgesState = {
  providerById: {
    [id: string]: {
      availabilityPercentage: number;
      badgeType: string;
      badgeBackgroundColor: string;
      icon: (value?: boolean) => JSX.Element;
      headerText: string;
      bodyText: string;
    }
  }
  isLoadedFromSearch: boolean;
};

const model = createModel<RootModel>()({
  name: 'providerAvailabilityBadgesFromSearch',

  state: {
    providerById: {},
    isLoadedFromSearch: false,
  } as ProviderAvailabilityBadgesState,

  // updating the data
  // effects: dispatch => (payload(as object), origin state)
  effects: dispatch => ({
    updateData: ({
      proId,
      availabilityPercentage,
      badgeType,
      badgeBackgroundColor,
      icon,
      headerText,
      bodyText,
    }: {
      proId: any;
      availabilityPercentage: number;
      badgeType: string;
      badgeBackgroundColor: string;
      icon: (value?: boolean) => JSX.Element;
      headerText: string;
      bodyText: string;
    }) => {
      if (badgeType) {
        dispatch.providerAvailabilityBadgesFromSearch.onUpdatingData({
          proId,
          availabilityPercentage,
          badgeType,
          badgeBackgroundColor,
          icon,
          headerText,
          bodyText,
        });
      }
    },
  }),

  // setting data
  reducers: {
    onUpdatingData: (
      state: ProviderAvailabilityBadgesState,
      {
        proId,
        availabilityPercentage,
        badgeType,
        badgeBackgroundColor,
        icon,
        headerText,
        bodyText,
      }: {
        proId: any;
        availabilityPercentage: number;
        badgeType: string;
        badgeBackgroundColor: string;
        icon: (value?: boolean) => JSX.Element;
        headerText: string;
        bodyText: string;
      },
    ) => ({
      ...state,
      providerById: {
        [proId]: {
          availabilityPercentage,
          badgeType,
          badgeBackgroundColor,
          icon,
          headerText,
          bodyText,
        },
      },
      isLoadedFromSearch: true,
    }),
  },

  // getting data from the state;
  selectors: (slice, createSelector, hasProps) => ({
    getAvailabilityBadge: hasProps((_, {
      proId,
    }: {
      proId: any,
    }) => createSelector(
      slice,
      (
        state: ProviderAvailabilityBadgesState,
      ) => state?.providerById?.[proId].badgeType,
    )),
  }),
});

export default model;
